export enum StreamStatus {
  Scheduled = 'Scheduled',
  Initializing = 'Initializing',
  Live = 'Live',
  Complete = 'Complete',
  Error = 'Error',
  Processing = 'Processing',
  Restarting = 'Restarting',
  // Stream host is healthy but the source RTMP feed is not publishing yet. The
  // host keeps re-probing and starts the stream by itself once the feed appears,
  // so the only action needed is getting the feed up. Shown as "Waiting for feed"
  // - see streamStatusToLabel.
  AwaitingSource = 'AwaitingSource',
  // The feed was publishing and then went away for good - the host waited out its
  // reconnect window and the source never came back. Transient: vault-api stops
  // the event and processes the recording, so this moves to Processing within
  // seconds. Shown as "Feed ended, stopping" - see streamStatusToLabel.
  SourceEnded = 'SourceEnded',
}
